import { createContext } from 'react'

export const AppNavigationGroupContext = createContext<null | boolean>(null)